// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"5dd67e12","166":"683cc4f1","182":"69d42352","241":"e9317603","309":"142c0d03","370":"ee98616b","418":"ef8536b3","419":"4754908a","982":"3941252b","989":"f7bf33f1"}[chunkId] + ".chunk.js";
};